import { memo } from 'react';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import { Typography } from '@components/Typography';
import Bar from '@components/Charts/Bar';
import { styled } from '@mui/system';

const PaperStyled = styled(Paper)({
    width: '100%',
    height: '100%',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    marginBottom: 0,
    marginTop: 0,
    '@media print': {
        breakInside: 'avoid',
    },
});

const ChartContainer = styled(TableContainer)({
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
});

const ChartWrapper = styled('div')({
    position: 'relative',
    flex: '1 1 auto',
    minHeight: '240px',
    '@media (max-width: 1024px)': {
        flex: 'none',
        height: '400px',
        width: '900px',
    },
    '@media print': {
        flex: 'none',
        height: '280px !important',
    },
});

const createChartData = (labels, positiveData, negativeData, legends) => ({
    labels,
    datasets: [
        {
            type: 'bar',
            label: legends[1],
            data: negativeData,
            backgroundColor: '#FF5853',
            hoverBackgroundColor: '#FF5853',
            categoryPercentage: 0.8,
            barPercentage: 0.7,
            borderWidth: 0,
            borderRadius: 8,
        },
        {
            type: 'bar',
            label: legends[0],
            data: positiveData,
            backgroundColor: '#4CC474',
            hoverBackgroundColor: '#4CC474',
            categoryPercentage: 0.8,
            barPercentage: 0.7,
            borderWidth: 0,
            borderRadius: 8,
        },
    ],
});

const chartOptions = {
    scales: {
        x: {
            stacked: false,
            ticks: {
                callback: function (_, index) {
                    return this.getLabelForValue(index);
                },
            },
        },
        y: {
            stacked: false,
            title: {
                display: false,
            },
        },
    },
};

const ReviewsDistributionChart = memo(({ title, labels, positiveData, negativeData, legends, chartId, styles }) => {
    return (
        <PaperStyled elevation={1} sx={styles}>
            <Typography variant="title1" sx={{ color: 'rgba(0,0,0, 0.87)', marginBottom: '24px' }}>
                {title}
            </Typography>
            <ChartContainer>
                <ChartWrapper id={chartId}>
                    {labels.length > 0 && (
                        <Bar
                            parentId={chartId}
                            data={createChartData(labels, positiveData, negativeData, legends)}
                            labels={labels}
                            optionsProps={chartOptions}
                        />
                    )}
                </ChartWrapper>
            </ChartContainer>
        </PaperStyled>
    );
});

ReviewsDistributionChart.displayName = 'ReviewsDistributionChart';

export default ReviewsDistributionChart;
